import { useState } from '@wordpress/element';
import playIcon from '../assets/play.svg';

const GetVideo = ({ video }) => {

    const [play, setPlay] = useState(false);
    const url = play
        ? video.video_url + `?autoplay=1&mute=1`
        : video.video_url;

    return(
        <div className={`blog-grid__video`}>        
            <div className={`blog-grid__video-src`}>
                {video.video_image && (
                    <div className={`blog-grid__video-img ${play ? 'remove' : 'show'}` } onClick={() => setPlay(true)}>
                        <div class={`blog-grid__video-img-play`}>
                            <img src={ playIcon } alt={`Play Video`}/>
                        </div>
                        {video.video_text && (
                            <div className={`blog-grid__video-text`}>
                                <p>{video.video_text}</p>
                            </div>
                        )}
                        <img class={`blog-grid__video-img-bg`} src={video.video_image} alt={`Video Still Image`} />
                    </div>
                )}
                <iframe src={url} frameborder="0" allowfullscreen />
            </div>
        </div>
    )
}

export default GetVideo;